import { createApiRef } from '@backstage/core-plugin-api';
import { CreateWorkloadRequest } from './dto/request/create-workload.request';
import { CreateWorkloadRoot } from './dto/response/create-workload.response';
import { GetWorkloadsRoot } from './dto/response/get-workloads.response';
import { GetPipelineLog } from './dto/response/get-pipeline-log.response';

export interface WorkloadApi {
    getWorkloads: (environment: string, system_name: string, application_name: string) => Promise<GetWorkloadsRoot>;
    createWorkloadDeploy: (environment: string, system_name: string, body: CreateWorkloadRequest) => Promise<CreateWorkloadRoot>;
    getPipelineLog: (environment: string, system_name: string, application_name: string, pipeline_id: number) => Promise<GetPipelineLog>;
}

export const WorkloadApiRef = createApiRef<WorkloadApi>({
    id: 'plugin.workload-deploy-api.service'
})